'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './settings-edit.routes';

export class SettingsEditComponent {
  constructor(SettingsService, Auth, $state, $stateParams, dialogs) {
    'ngInject';

    this.SettingsService = SettingsService;

    this.settingsId = $stateParams.id;

    this.dialogs = dialogs;

    this.jsonValue = "";
    this.$state = $state;

    this.settingsTemplate = {
      name: '',
      description: '',
      data: {},
      meta: {
        creationUser: Auth.getCurrentUserSync()._id,
        active: true
      }
    };

    this.settings = angular.copy(this.settingsTemplate);

    if (this.settingsId) {
      this.SettingsService.get({id: this.settingsId}, data => {
        this.settings = data;
        this.jsonValue = data.data === null ? '' : angular.toJson(data.data, true);
      }, err => {
        console.log('Could not load settings from server');
      })
    }

    CodeMirror.defineOption("matchBrackets", true);
    CodeMirror.defineOption("autoCloseBrackets", true);
    CodeMirror.defineOption("lineWrapping", true);
    CodeMirror.defineOption("tabSize", 2);
    CodeMirror.defineOption("mode", "application/json");
    CodeMirror.defineOption("gutters", ["CodeMirror-lint-markers"]);
    CodeMirror.defineOption("lint", true);
    CodeMirror.defineOption("styleActiveLine", true);
    CodeMirror.defineOption("lineNumbers", true);
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        this.settings = angular.copy(this.settingsTemplate);
        this.submitted = false;

        var actionString = (this.settingsId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The settings have been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go("settings-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      this.settings.data = angular.fromJson(this.jsonValue);

      if (this.settingsId) {  // Save changes on the current settings
        this.SettingsService.update({id: this.settingsId}, this.settings, onSuccess, onError);
      } else { // Create new settings
        this.SettingsService.save(this.settings, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduu.settingsEdit', [uiRouter])
  .config(routes)
  .component('settingsEdit', {
    template: require('./settings-edit.html'),
    controller: SettingsEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/settings-edit/settings-edit.component.js